import axiosapi from "./axiosAPI";

// Get All Roles
export const getAllRoles = async (
    setRoles,
    setFetcherror,
    callback

) => {
    
    
	try{
		const res =await axiosapi.get("/roles");
        setRoles(res.data.data ? res.data.data : {});
        if(callback && typeof callback === "function"){
            callback(res.data.data, null);
        }
	}
	catch(err){
		if(err.response){
            setFetcherror("Error: Could Not Fetch Roles");
            if(callback && typeof callback === "function"){
                callback(null, true);
            }
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Roles");
            if(callback && typeof callback === "function"){
                callback(null, true);
            }
		}
		
	}
	
};



// Get One Role
export const getOneRole = async (
    pkid,
    setFetcherror,  
    setRole
    
)=>{
	try{
		const res =await axiosapi.get(`/roles/${pkid}`);
        setRole(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Role");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Role");
		}
		
	}
	
};


// Create New Role
export const createRole = async (
    roleName,
    setRoleName,
    roleDescription,
    setRoleDescription,
    setFetcherror,
    handleAllToasts,
    setRoles

) => {
    console.log("Role2BCreated:", roleName,roleDescription);

    // e.preventDefault();

    if (!roleName || !roleDescription) {
        handleAllToasts(2, "Either Role or Description has not been provided"); 
            return; 
        }

    const PushItem = {
        name: roleName,
        description:roleDescription,
        };

    
    try{
        await axiosapi.post("/roles/",PushItem );
        setRoleName("");
        setRoleDescription("");
        handleAllToasts(1, "Role Created Successfully");
        getAllRoles(setRoles, setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Role");
            handleAllToasts(2, "Could Not Create The Role");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Role");
            handleAllToasts(2, "Could Not Create The Role");
            
        }
        
    }
    
}


// Edit Existing Role

export const editRole = async (
    rolepkid,
    roleName,
    setRoleName,
    roleDescription,
    setRoleDescription,
    setFetcherror,
    handleAllToasts,
    setRoles
              
) => {
    console.log("PKID,Name,Description", rolepkid, roleName, roleDescription);

            if (!roleName || !roleDescription) {
                handleAllToasts(2, "Either Role or  Name has not been Provided"); 
                    return;  
                }

            const PushItem = {

                    id:rolepkid,
                    name: roleName,
                    description:roleDescription
                };

            try{
                await axiosapi.patch("/roles/",PushItem );
                setRoleName("");
                setRoleDescription("");
                handleAllToasts(1, "Role Updated Successfully");
                getAllRoles(setRoles, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Role");
                    handleAllToasts(2, "Could Not Update Role");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Role");
                    handleAllToasts(2, "Could Not Update Role");
                    
                }
                
            }
            
};



// Delete Existing Role.

export const deleteRole = async (
    rolepkid,
    setRoles,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/roles/${rolepkid}`);
        let finalData = res.data.message;
        getAllRoles(setRoles, setFetcherror);
        handleAllToasts(1, "Role Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Role");
            handleAllToasts(2,"Error: Could Not Delete Role");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Role");
            handleAllToasts(2,"Error: Could Not Delete Role");
		}
		
	}
	
};